import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.jsx';
import { AuthProvider, RequireAuth } from './auth.jsx';
import { ModelProvider } from './state.jsx';
import './styles/legacy.css';
import './styles/app.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <ModelProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ModelProvider>
        </QueryClientProvider>
      </RequireAuth>
    </AuthProvider>
  </StrictMode>,
);
